class LoadingAnimationController {
    constructor() {
        'ngInject';
    }
}

export const LoadingAnimationComponent = {
    name: 'loadingAnimation',
    component: {
        //template: `<div class="lds-heart"><div></div></div>`,
        template: '<div>Loading...</div>',
        controller: LoadingAnimationController,
        bindings: {
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/loadingAnimation.component.js